import { toast } from "sonner";

export const showSuccessAlert = (message) => {
  toast.success(message, {
    position: "top-right",
  });
};

export const showErrorAlert = (message) => {
  toast.error(message, {
    position: "top-right",
  });
};
